export default __webpack_public_path__ + "static/media/20200721-Oracle SQL Certificate.b20631bf.pdf";